import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/EiInformation';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import ReviewPdf from '../../../../Shared/Card/ReviewPdf';
import reinstatementService from '../../../../../services/Internal/Reinstatement/reinstatement.service';
import eiReinstatementService, { getSections } from '../../../../../services/Internal/Reinstatement/EI/eiReinstatement.service';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Swal from 'sweetalert2';
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons';
import { Form } from 'rsuite';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import BaseSummarySheet from '../../../SummarySheets/BaseSummarySheet';
import SummarySheetPdf from '../../../SummarySheets/SummarySheetPdf';


function ReviewPage() {
    const [hasLoaded, setHasLoaded] = useState(false)
    const [saveSummarySheet, setSaveSummarySheet] = useState(0)
    const [downloadSummarySheet, setDownloadSummarySheet] = useState(0)
    const [downloadCombo, setDownloadCombo] = useState(0)
    const push = useNavigate();
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const routes = useSelector(x => x.currentRoutes);
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Engineer Intern Reinstatement",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Review"
        }
    );
    const sectionId = 10;

    useEffect(() => {
        eiReinstatementService.eiGetSection(reinstatementId, sectionId).then((response) => {
            setIsComplete(response.data.staffReviewComplete);
            reinstatementService.getIndividualReinstatement(reinstatementId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted,
                            formType: data.data?.isOverFiveYears ? "Engineer Intern Reinstatement (5 plus years)" : entityInfo.formType
                        })
                    setHasLoaded(true);
                });
            });
        })
    }, [])
    const formSubmit = () => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            setSaveSummarySheet(saveSummarySheet + 1);
            eiReinstatementService.eiMarkSectionComplete(reinstatementId, sectionId, isComplete).then((data) => {
                if (data.data)
                    push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
            })
        }
    }
    const formSave = () => {
        eiReinstatementService.eiMarkSectionComplete(reinstatementId, sectionId, isComplete).then((data) => {
            if (data.data)
                Swal.fire("Saved!");
        })
    }



    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Row>
                    <Col>
                        <Information content={GetAppInformationContent("review")} className="mb-3" />
                    </Col>
                </Row>
                <br />
                <ReviewPdf id={reinstatementId} parentTypeId={2} />
                <SummarySheetPdf
                    downloadSummarySheet={downloadSummarySheet}
                    setDownloadSummarySheet={setDownloadSummarySheet}
                    downloadCombo={downloadCombo}
                    setDownloadCombo={setDownloadCombo}
                    id={reinstatementId}
                    parentTypeId={2}
                />
                <br />
                <br />
                {hasLoaded ?
                    <>
                        <BaseSummarySheet
                            isUserEditable={isUserEditable}
                            entityId={entityInfo.entityId}
                            parentId={reinstatementId}
                            saveSummarySheet={saveSummarySheet}
                            parentTypeId={2}//im aware this looks wrong but the way the code table works this needs to be like this
                            appTypeId={3}
                            downloadSummarySheet={downloadSummarySheet}
                            setDownloadSummarySheet={setDownloadSummarySheet}
                            downloadCombo={downloadCombo}
                            setDownloadCombo={setDownloadCombo}
                        />
                        <br />
                        <br />
                        <Form onSubmit={formSubmit}>
                            <FormActionButtons
                                isUserEditable={isUserEditable}
                                isComplete={isComplete}
                                isCompleteCallback={setIsComplete}
                                showSectionComplete={true}
                                backToSectionLink="/internal/eireinstatement/sections"
                                handleSave={formSave} />
                        </Form>
                    </>
                    : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default ReviewPage